// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__26ZnW","col":"CardReaderDesc_col__1seCE","label":"CardReaderDesc_label__2LpzQ"};